@if (current(); as r) {
  <button
    type="button"
    class="release-context-chip"
    [cdkMenuTriggerFor]="releaseMenu"
    (cdkMenuOpened)="onOpened()"
    aria-label="Change release"
    title="Change release"
  >
    <span class="dot" aria-hidden="true"></span>
    <span class="release-context-name">{{ r.releaseName }}</span>
    <svg class="caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <path d="m6 9 6 6 6-6" />
    </svg>
  </button>
}

<ng-template #releaseMenu>
  <div class="popover release-switcher" cdkMenu>
    @if (isLoading() && !hasOptions()) {
      <div class="release-switcher-note">Loading releases…</div>
    } @else if (!hasOptions()) {
      <div class="release-switcher-note">No releases to switch to.</div>
    } @else {
      @if (activeReleases().length) {
        <div class="popover-label">Active</div>
        @for (active of activeReleases(); track active.releaseId) {
          <button
            type="button"
            class="popover-item release-switcher-item"
            [class.active]="isCurrent(active)"
            [attr.aria-current]="isCurrent(active) ? 'true' : null"
            cdkMenuItem
            (click)="select(active)"
          >
            <span class="release-switcher-name">{{ active.releaseName }}</span>
            <span class="release-switcher-status active">Active</span>
          </button>
        }
      }

      @if (recentReleases().length) {
        <div class="popover-label">Recent</div>
        @for (r of recentReleases(); track r.releaseId) {
          <button
            type="button"
            class="popover-item release-switcher-item"
            [class.active]="isCurrent(r)"
            [attr.aria-current]="isCurrent(r) ? 'true' : null"
            cdkMenuItem
            (click)="select(r)"
          >
            <span class="release-switcher-name">{{ r.releaseName }}</span>
            <span
              class="release-switcher-status"
              [class.shipped]="r.status === 'Shipped'"
              [class.held]="r.status === 'Held'"
            >
              {{ r.status }}
            </span>
          </button>
        }
      }
    }

    <div class="popover-divider"></div>
    <a class="popover-item release-switcher-all" cdkMenuItem routerLink="/releases">
      See all releases
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14" aria-hidden="true">
        <path d="M5 12h14M13 6l6 6-6 6" />
      </svg>
    </a>
  </div>
</ng-template>
